// extracted by mini-css-extract-plugin
export default {"Trendings":"Trending_Trendings__LuhCp","trendingsH2":"Trending_trendingsH2__b8V25","trending":"Trending_trending__5NkH1","shake":"Trending_shake__dJ1ls"};